import React, { JSX, useCallback } from 'react';

import { borderRadius, Col, Cols, spacing, Text, TKey } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export interface RadioOption {
  tKey: TKey;
  value: string | number;
  stickerTKey?: TKey;
  stickerColor?: string;
  stickerBackgroundColor?: string;
}

interface RadioTextButtonsProps {
  options: RadioOption[];
  value: string | number;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export const RadioTextButtons = React.memo(
  ({ options, value, onChange, disabled }: RadioTextButtonsProps): JSX.Element => {
    const handleClick = useCallback(
      (optionValue: string | number) => () => {
        if (!disabled) {
          onChange(optionValue.toString());
        }
      },
      [onChange],
    );

    return (
      <Cols gap={spacing.large}>
        {options.map((option) => {
          const isSelected = value === option.value;
          return (
            <Col
              key={option.value}
              onClick={handleClick(option.value)}
              style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
            >
              <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
                <Col>
                  <Text
                    bold
                    tKey={option.tKey}
                    color={
                      isSelected
                        ? publicaColors.blue
                        : disabled
                        ? publicaColors.lightGray
                        : publicaColors.gray
                    }
                  />
                </Col>
                {option.stickerTKey && !disabled && (
                  <Col
                    style={{
                      backgroundColor: option?.stickerBackgroundColor || publicaColors.lightRed,
                      padding: '2px 4px',
                      borderRadius: borderRadius.small,
                      display: 'inline-block',
                      width: 'fit-content',
                      opacity: isSelected ? 1 : 0.5,
                    }}
                  >
                    <Text
                      mini
                      heavy
                      tKey={option.stickerTKey}
                      color={option?.stickerColor || publicaColors.white}
                      style={{ textTransform: 'uppercase' }}
                    />
                  </Col>
                )}
              </Cols>
            </Col>
          );
        })}
      </Cols>
    );
  },
);
